import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../lib/api';

/**
 * VisitTracker — fires a /api/analytics/track call on every route change.
 * Fire-and-forget. Avoids double-tracking the same path within 1 second.
 */
export const VisitTracker = () => {
  const location = useLocation();
  const lastRef = useRef({ path: '', at: 0 });

  useEffect(() => {
    const now = Date.now();
    if (lastRef.current.path === location.pathname && now - lastRef.current.at < 1500) return;
    lastRef.current = { path: location.pathname, at: now };
    const lang = (location.pathname.match(/^\/([a-z]{2})(\/|$)/) || [, 'fr'])[1];
    api.trackSiteVisit(location.pathname, lang, document.referrer || '');
  }, [location.pathname]);

  return null;
};
